import { format } from 'owa-localize';
import attemptToSubmitAddEntityFeedback from './attemptToSubmitAddEntityFeedback';
import createEntityFeedbackEntry from './createEntityFeedbackEntry';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import EntityFeedbackEntry from 'owa-service/lib/contract/EntityFeedbackEntry';
import { action } from 'satcheljs/lib/legacy';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';

import { trace } from 'owa-trace';

/**
 * Logs Add entity feedback for location
 * @param feedbackManagerState: the feeback manager
 * @param recipientEmailAddresses: the array of recipient email addresses
 */
export default action('removeEntity')(function removeEntity(
    feedbackManagerState: FeedbackManagerState,
    recipientEmailAddresses: string[]
) {
    if (feedbackManagerState) {
        if (!recipientEmailAddresses) {
            trace.warn(
                format(
                    '{0} - Attempting to remove entity without recipientEmailAddresses',
                    feedbackManagerState.entityScenarioName
                )
            );
            return null;
        }

        if (feedbackManagerState.hasSessionStarted) {
            let targetList = JSON.stringify(recipientEmailAddresses);

            let entry: EntityFeedbackEntry = createEntityFeedbackEntry(
                feedbackManagerState,
                '' /* transactionId */,
                'EntityRemoved',
                targetList,
                EntityAddSource.None,
                '' /* jsonPropertyBag */
            );

            attemptToSubmitAddEntityFeedback(feedbackManagerState, entry, false);

            trace.info(
                format(
                    '{0} Removed Entity {1}. Session id: {2}',
                    feedbackManagerState.entityScenarioName,
                    targetList,
                    feedbackManagerState.clientSessionId
                )
            );
        }
    }
});
